import React from 'react';
import { Outlet } from 'react-router-dom';
import Sidebar from '../components/layout/Sidebar';

const ComponentsLayout: React.FC = () => {
  return (
    <div className="flex flex-col md:flex-row gap-6">
      <div className="md:w-[250px] md:min-w-[150px] md:max-w-[300px] md:flex-shrink-0">
        <div className="sticky top-4 h-[calc(100vh-8rem)] overflow-y-auto">
          <Sidebar pageType="components" />
        </div>
      </div>
      
      <div className="flex-grow overflow-y-auto pb-16">
        <Outlet />
      </div>
    </div>
  );
};

export default ComponentsLayout; 